import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "text-center" }
const _hoisted_3 = { class: "text-center mt-4" }

import CollapsibleItem from "../../layout/collapsible/CollapsibleItem.vue";
import schemaVisite from "@/../../EshJSLib/models/form/visite.json";
import rilevazioniVisite from "@/../../EshJSLib/models/form/rilevazioni.json";
import { storeToRefs } from "pinia";
import { patientStore } from "../../store/patient";
import ModalEdit from "../../views/Visite/modal_edit.vue";
import ModalAdd from "../../views/Visite/modal_add.vue";
import AlertModal from "@/components/AlertModalFeedback.vue";
import { TblParametriVitali, Visite } from "@/../../EshJSLib/models/patient";
import { deletePatient } from "@/../../EshJSLib/services/visiteServices";
import { Vue } from "vue-class-component";
import { onMounted, ref, reactive } from "vue";
import { useRouter } from "vue-router";
import { Modal } from "flowbite-vue";
import { hasPermission } from "../../../../EshJSLib/services/securityServices";


export default /*#__PURE__*/_defineComponent({
  __name: 'VisitePage',
  setup(__props) {

const store = patientStore();
const { patient } = storeToRefs(store);
const showLoading = ref(false);
const router = useRouter();
const isShownModal = reactive({
    alert: false,
    movePage: false,
    confirm: false,
    alertMove: false,
});

function movePage() {
    router.push({ path: 'Paypal' })
}

onMounted(async () => {
    store.fetchVisite();
    store.fetchRilevazioni();
});

//Ref Element with HTML
const alertModal = ref<InstanceType<typeof AlertModal> | null>(null);
const modalEditVisite = ref<InstanceType<typeof ModalEdit> | null>(null);
const modalAddVisite = ref<InstanceType<typeof ModalAdd> | null>(null);

async function action(type: string, row: Visite, newRow: Visite) {
    let userInput;
    switch (type) {
        case "trash":
            alertModal.value.openModal("Sei sicuro di cancellare la visita?", true).then((userInput) => {
                if (userInput) {
                    showLoading.value = true;

                    deletePatient(row.id_visita)
                        .then((response) => {
                            showLoading.value = false;
                            if (response.status === 200) {
                                alertModal.value?.openModal("Visita eliminata con successo!", false);
                            }
                            store.fetchVisite();
                        })
                        .catch((error) => {
                            showLoading.value = false;
                            alertModal.value?.openModal("Visita non eliminata, riprova", false);
                            store.fetchVisite();
                        });
                }
            });
        break;

        case "pen":
            if (await hasPermission('modificavisite')) {
                userInput = await modalEditVisite.value?.openModal("Modifica visite", true, row as unknown as Visite);
                
                if (userInput) {
                    showLoading.value = true;
                    store.savePaziente("visite", row.id_visita).then((x) => {
                        store.fetchVisite().then(() => {
                            showLoading.value = false;
                        })
                    });
                } else {
                    store.fetchVisite();
                }
            } else {
                isShownModal.alert = true;
            }
        break;

        case "newRecord":
            if (await hasPermission('aggiungivisite')) {
                newRow = {} as Visite;
                newRow.id_visita = 0;
                newRow.id_paziente = patient.value.id_paziente;
                userInput = await modalAddVisite.value?.openModal(null, true, newRow);

                if (userInput) {
                    showLoading.value = true;
                    patient.value.visite.push(newRow);
                    store.savePaziente("visite", newRow.id_visita).then((x) => {
                        store.fetchVisite().then(() => {
                            showLoading.value = false;
                        })
                    });
                }
            } else {
                isShownModal.alert = true;
            }
        break;

        default:
        break;
    }
}

async function actionRilevazioni(type: string, row: TblParametriVitali, newRow: TblParametriVitali) {
    let userInput;
    switch (type) {
        case "trash":
            alert('Funzione non ancora disponibile');
        break;

        case "pen":
            alert('Funzione non ancora disponibile');
        break;

        case "newRecord":
            alert('Funzione non ancora disponibile');
        break;

        default:
        break;
    }
}

return (_ctx: any,_cache: any) => {
  const _component_LoadingComponent = _resolveComponent("LoadingComponent")!

  return (_unref(patient))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(ModalEdit, {
          ref_key: "modalEditVisite",
          ref: modalEditVisite
        }, null, 512),
        _createVNode(ModalAdd, {
          ref_key: "modalAddVisite",
          ref: modalAddVisite
        }, null, 512),
        (showLoading.value)
          ? (_openBlock(), _createBlock(_component_LoadingComponent, { key: 0 }))
          : _createCommentVNode("", true),
        _createVNode(AlertModal, {
          ref_key: "alertModal",
          ref: alertModal
        }, null, 512),
        _createVNode(CollapsibleItem, {
          id: "visiteCollaps",
          data: _unref(schemaVisite),
          onRowActions: _cache[0] || (_cache[0] = (n, r, i) => action(n, r, i)),
          onCreateForm: _cache[1] || (_cache[1] = ($event: any) => (action('newRecord', null, null)))
        }, null, 8, ["data"]),
        _createVNode(CollapsibleItem, {
          id: "rilevazioniCollaps",
          data: _unref(rilevazioniVisite),
          onRowActions: _cache[2] || (_cache[2] = (n, r, i) => actionRilevazioni(n, r, i)),
          onCreateForm: _cache[3] || (_cache[3] = ($event: any) => (action('newRecord', null, null)))
        }, null, 8, ["data"]),
        (isShownModal.alert)
          ? (_openBlock(), _createBlock(_unref(Modal), {
              key: 1,
              onClose: _cache[6] || (_cache[6] = ($event: any) => (isShownModal.alert = false))
            }, {
              body: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t("Questa sezione non è prevista nella tua sottoscrizione")), 1),
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("button", {
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (isShownModal.alert = false)),
                    type: "button",
                    class: "text-gray-900 bg-white border border-gray-300 focus:outline-none hover:bg-gray-100 focus:ring-4 focus:ring-gray-200 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 dark:bg-gray-800 dark:text-white dark:border-gray-600 dark:hover:bg-gray-700 dark:hover:border-gray-600 dark:focus:ring-gray-700"
                  }, _toDisplayString(_ctx.$t("Annulla")), 1),
                  _createElementVNode("button", {
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (movePage())),
                    type: "button",
                    class: "text-white bg-gray-800 hover:bg-gray-900 focus:outline-none focus:ring-4 focus:ring-gray-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 dark:bg-gray-800 dark:hover:bg-gray-700 dark:focus:ring-gray-700 dark:border-gray-700"
                  }, _toDisplayString(_ctx.$t("Iscriviti")), 1)
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})